import { render, staticRenderFns } from "./peosonalDetail.vue?vue&type=template&id=14a4b000"
import script from "./peosonalDetail.vue?vue&type=script&lang=js"
export * from "./peosonalDetail.vue?vue&type=script&lang=js"
import style0 from "./peosonalDetail.vue?vue&type=style&index=0&id=14a4b000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports